// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixWindow from 'wix-window';
	//TODO: write your page related code here...

$w.onReady(function () {
 
  let myLang = wixWindow.multilingual.currentLanguage; 
  if (myLang === 'he') {
    $w('#formeng').hide();
    $w('#formheb').show();
     $w('#form22').show();
     $w('#formeng2').hide();
     
  } else {
    $w('#formheb').hide();
    $w('#formeng').show();
    $w('#form22').hide();
    $w('#formeng2').show();
  }

});